var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.0076H15.1129M1 9.65885H5.65637M1 15.3101H7.31124",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4924 7.44379C12.9754 6.68069 14.1129 6.68081 14.5959 7.44379L14.6887 7.61957L15.6155 9.73285H17.6575C18.7544 9.73292 19.3193 11.0454 18.5657 11.8422L16.76 13.7495L17.2776 16.0746C17.5184 17.1588 16.3308 17.9953 15.3909 17.4037L13.5452 16.2426L11.7034 17.4135C10.7638 18.0099 9.5713 17.1729 9.81274 16.0864L10.3284 13.767L8.51587 11.8393C7.76582 11.0415 8.33108 9.73312 9.42603 9.73285H11.4729L12.3997 7.61957L12.4924 7.44379Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchList);
export default __webpack_public_path__ + "static/media/watch-list.78272a1f4f56c07dc3186ad0d4173d77.svg";
export { ForwardRef as ReactComponent };